import classNames from "classnames";
import { FC } from "react";
import { THEME, THEME_LIVE } from "../config";
import AHSpecial from "./ah-special";

export type SpecialProps = {
  oddsType?: number;
  title?: string;
  isLoading?: boolean;
  isLive?: boolean;
  leagueId?: string;
  matchId?: string;
  data?: {
    label: string;
    outcomeId: string;
    price: number;
    sp: string;
    marketId: string;
    matchId: string;
    spd: boolean;
  }[];
  onClick?: (data: {
    outcomeId: string;
    sp: string;
    marketId: string;
    matchId: string;
    leagueId: string;
    option: number;
  }) => void;
};

const Special: FC<SpecialProps> = ({
  isLoading = false,
  isLive = false,
  leagueId,
  matchId,
  title,
  data = [],
  onClick,
  oddsType = 0,
}) => {
  const theme = isLive ? THEME_LIVE : THEME;
  return (
    <div className="flex flex-col">
      <div
        className={classNames(
          theme.primaryB,
          "text-white p-1 text-xs font-semibold border border-white"
        )}>
        {isLoading ? (
          <div className="rounded bg-gray-200 h-2 animate-pulse w-1/2" />
        ) : (
          title
        )}
      </div>
      <div className="flex text-center flex-wrap">
        {isLoading ? (
          <>
            <AHSpecial option={0} isLoading isLive={isLive} />
            <AHSpecial option={1} isLoading isLive={isLive} />
            <AHSpecial option={2} isLoading isLive={isLive} />
          </>
        ) : (
          data.map((each, index) => {
            return (
              <AHSpecial
                leagueId={leagueId}
                marketId={each.marketId}
                matchId={matchId}
                option={index}
                key={each.outcomeId}
                outcomeId={each.outcomeId}
                label={each.label}
                onClick={onClick}
                price={each.price}
                sp={each.sp}
                oddsType={oddsType}
                isLive={isLive}
                spd={each.spd}
              />
            );
          })
        )}
      </div>
    </div>
  );
};

export default Special;
